import { render, staticRenderFns } from "./IpAddresses.vue?vue&type=template&id=715f18bf&scoped=true&"
import script from "./IpAddresses.vue?vue&type=script&lang=js&"
export * from "./IpAddresses.vue?vue&type=script&lang=js&"
import style0 from "./IpAddresses.vue?vue&type=style&index=0&id=715f18bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f18bf",
  null
  
)

export default component.exports